/** @TODO Types */
const adminRoles = {
  "UPCLAIM_ADMIN": { text: "Admin Upclaim" },
  "LAWYER": { text: "Avocat" },
  "PLEADING_LAWYER": { text: "Avocat postulant" },
  "CUSTOMER_ADMIN": { text: "Administrateur" }, 
  "CUSTOMER_AGENT": { text: "Agent" },
  "CUSTOMER_ACCOUNT_MANAGER": { text: "Chargé de comptes (AM)" },
  "BUSINESS_TRAVEL_ADMIN": { text: "Admin" },
}

export {
  adminRoles
}